/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_TitleInputs */



/**
* | output |
* | --- |
* | "Merge Events" |
*
* @param {Merge_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_title = /** @type {((inputs?: Merge_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les Evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführungsereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをマージする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar eventos")
	return /** @type {LocalizedString} */ ("Merge Events")
});